export default __webpack_public_path__ + "static/media/CCMRCourseDescriptionV201.26e3bff9.png";